var isNull = function (value) {
    return value === null;
};
export default isNull;
//# sourceMappingURL=is-null.js.map